import { CarsState } from '../../types';

import { carsActions } from '../reducer';

export const updateCarLocationHistorySharingSelectedLocation = (
  value: CarsState['locationHistorySharing']['selectedLocation']
) => carsActions.setCarLocationHistorySharingSelectedLocation(value);
